module.exports = __webpack_public_path__ + "static/media/module3Success.7bb2a9bf.mp3";